<script setup lang="ts">
    import logo_ibew from '~/assets/images/logo_ibew.png'
    import logo_neat from '~/assets/images/logo_neat.png'
    import logo_neca from '~/assets/images/logo_neca.png'
    import { useDisplay, useTheme } from 'vuetify';
    import { useAppStore } from '#imports';
    import logo from '~/assets/images/logo_neat.png'

    /* Store variables */
    const { isDark, isMenu, isMobile, tagLine, txt } = storeToRefs(useAppStore());

    /* Private variables */
    const _display = useDisplay();
    const _theme = useTheme();

    isMobile.value = computed(() => { return _display.mobile.value; });
    _theme.global.name.value = isDark.value ? 'theme_dark' : 'theme_light';
</script>

<template>
    <v-app-bar>
        <v-app-bar-title class="ml-4 d-flex align-center">
            <div class="">
                <img class="mb-n1" :src="logo" height="20" width="70" />
                <p class="mt-n1 color-primary font-weight-bold text-subtitle-2">{{ tagLine }}</p>
            </div>
        </v-app-bar-title>
        <template #extension style="height: 0 !important">
            <v-fab
                absolute
                :class="isMenu ? 'ml-14 mt-12' : 'ml-4 mt-12'"
                color="tertiary"
                elevation="4"
                extended
                location="bottom start"
                :prepend-icon="isMenu ? 'mdi-menu-left' : 'mdi-menu-right'"
                :text="txt.calculationList"
                @click.stop="isMenu = !isMenu">
            </v-fab>
        </template>
        
      <v-row no-gutters
        class="align-center ga-6 justify-end ma-3">
        <img :src="logo_neat" height="15" />
        <img :src="logo_ibew" height="45" />
        <img :src="logo_neca" height="30" class="mb-2"/>
      </v-row>
    </v-app-bar>
</template>